import {
  ICICIMERCHANT,
  LENDINGKARTMERCHANT,
  IDFCMERCHANT,
  AXISEASYPAYPLUS,
  IMPORTS_TEST_MERCHANT,
  IMPORTS_PROD_MERCHANT,
} from './constants';

export const DESIGN_TOKENS = {
  [ICICIMERCHANT]: {
    COLORS: {
      bgLight: '#F8F8F8',
      primary: '#F26522',
      selected: '#F4E0E0',
      focused: '#A30000',
    },
    GLOBAL_SIDEBAR: {
      brandBg: '#FFFFFF',
      bg: '#F26522',
      selected: '#951E11',
      text: '#FFFFFF',
      primaryBtn: '#FFFFFF',
      secondaryBtn: '#FFFFFF',
      envSwitch: '#FFFFFF',
      envSwitchAlt: '#951E11',
      envSwitchAltHover: '#951E11aa',
    },
  },
  [LENDINGKARTMERCHANT]: {
    COLORS: {
      bgLight: '#F8F8F8',
      primary: '#FF7000',
      selected: '#F5E5D7',
      focused: '#F26522',
    },
    GLOBAL_SIDEBAR: {
      brandBg: '#FFFFFF',
      bg: '#FF7000',
      selected: '#294E9B',
      text: '#FFFFFF',
      primaryBtn: '#FFFFFF',
      secondaryBtn: '#FFFFFF',
      envSwitch: '#FFFFFF',
      envSwitchAlt: '#FF7000',
      envSwitchAltHover: '#ff7000aa',
    },
  },
  [IDFCMERCHANT]: {
    COLORS: {
      bgLight: '#F8F8F8',
      primary: '#9D1D27',
      selected: '#f5e5d7',
      focused: '#8b2b32',
    },
    GLOBAL_SIDEBAR: {
      brandBg: '#FFFFFF',
      bg: '#9D1D27',
      selected: '#380808',
      text: '#FFFFFF',
      primaryBtn: '#FFFFFF',
      secondaryBtn: '#FFFFFF',
      envSwitch: '#FFFFFF',
      envSwitchAlt: '#380808',
      envSwitchAltHover: '#380808aa',
    },
  },
  [AXISEASYPAYPLUS]: {
    COLORS: {
      bgLight: '#F4F6F9',
      primary: '#AE285D',
      selected: '#FFE4EF',
      focused: '#870337',
    },
  },
  [IMPORTS_TEST_MERCHANT]: {
    COLORS: {
      focused: '#584F8E',
    },
  },
  [IMPORTS_PROD_MERCHANT]: {
    COLORS: {
      focused: '#130951',
    },
  },
};

export default DESIGN_TOKENS;
